import { FormValueScope, SelectableInputField } from '@epages/react-components'
import type { Ref } from 'react'
import Immutable from 'immutable'

import { useTranslate } from '../../utils/translate'

export default function FooterContactSettings({ fieldsetRef }: Readonly<{ fieldsetRef: Ref<HTMLFieldSetElement> }>) {
  const t = useTranslate('interface', 'components.bottomBar.footerSettings.sections.popovers.contactSelection')

  return (
    <FormValueScope name="contact">
      <fieldset ref={fieldsetRef}>
        <legend>{t('title')}</legend>
        <div className="ep-footer-sections-settings-popover-column ep-footer-sections-settings-popover-contact">
          <SelectableInputField
            type="tel"
            name="phone"
            title={t('contact.phoneInputField.tooltip')}
            aria-label={t('contact.phoneInputField.ariaLabel')}
            label={t('contact.phoneInputField.checkBoxAccessibilityLabel')}
          />
          <SelectableInputField
            type="email"
            name="email"
            data-testid="contact-popover-email-field"
            title={t('contact.emailInputField.tooltip')}
            aria-label={t('contact.emailInputField.ariaLabel')}
            label={t('contact.emailInputField.checkBoxAccessibilityLabel')}
          />
          <SelectableInputField
            name="address"
            title={t('contact.addressInputField.tooltip')}
            aria-label={t('contact.addressInputField.ariaLabel')}
            label={t('contact.addressInputField.checkBoxAccessibilityLabel')}
          />
        </div>
      </fieldset>
    </FormValueScope>
  )
}

FooterContactSettings.defaultValue = Immutable.fromJS({
  phone: '',
  phoneSelected: false,
  email: '',
  emailSelected: false,
  address: '',
  addressSelected: false,
})
